null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala/v2.12.8/src/library/scala/runtime/AbstractFunction1.scala